module.exports = __webpack_public_path__ + "media/tol/bghead-668f670f.png";